
import { Component, Vue, Prop} from 'vue-property-decorator';
import RflmChildrenSurvey from "./RflmChildrenSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";

import {SearchForChildrenData} from "@/components/utils/ChildrenData/SearchForChildrenData";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
      RflmChildrenSurvey,
      PageBase
    }
})
export default class RflmChildrenInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;
    childBestInterestUnderstanding = false;
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;  
    includesCounter = null;    
    correctChildInfo = null; 
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('child-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childData?.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childData = [...this.childData, newChild];

        this.showTable = true; 
        this.resetChildrenRelatedPages(this.childData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetChildrenRelatedPages(this.childData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetChildrenRelatedPages(this.childData);
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.correctChildInfo) {
            this.correctChildInfo = this.step.result.correctChildInfo;
        }

        if (this.step.result?.childrenInfoSurvey) {
            this.childData = this.step.result.childrenInfoSurvey.data;
        }
        if (this.step.result?.rflmChildBestInterestAcknowledgement) {
            this.childBestInterestUnderstanding = this.step.result.rflmChildBestInterestAcknowledgement;
        }

        if(this.childData?.length == 0){
            this.childData= SearchForChildrenData('RFLM');            
        }

        this.includesCounter = 'No';

        if (this.step.result?.rflmCounterAppSurvey?.data) {
            const counterAppData = this.step.result.rflmCounterAppSurvey.data;
            this.includesCounter = this.childRelatedCounter(counterAppData.counter, counterAppData.counterList)?'Yes':'No';           
        }       
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public childRelatedCounter(counter, selectedCounters){

        const childRelated = (counter == 'Yes' && 
                (selectedCounters.includes('parentingArrangements') ||
                selectedCounters.includes('childSupport') ||
                selectedCounters.includes('contactWithChild') ||
                selectedCounters.includes('guardianOfChild')));

        return childRelated;
    }

    public surveyHasError(){
        let progress = this.childData.length==0? 50 : 100;
        
        if(this.correctChildInfo == 'Yes' && this.includesCounter == 'No') progress =100;

        this.incompleteError =  false;        
        for(const child of this.childData){
            if (((this.includesCounter=='No') && !child.dob) || 
                ((this.includesCounter=='Yes') && (!child.dob || !child.relation || !child.opRelation || !child.currentLiving))){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    get displayAcknowledgement(){

        let display = false;

        const includesCounterChildData = this.includesCounter=='Yes' && this.childData && this.childData.length > 0;
        const includesCorrectedChildData = this.correctChildInfo == 'No' && this.childData && this.childData.length > 0;
        const noChildDataRequired = this.includesCounter=='No' && this.correctChildInfo == 'Yes';

        display = (this.showTable && (includesCounterChildData || includesCorrectedChildData)) || noChildDataRequired;

        return display;
    }

    public isDisableNext() {
        return (!this.correctChildInfo || (this.correctChildInfo == 'No' && this.childData?.length <= 0 ) || 
            (this.includesCounter == 'Yes' && this.childData?.length <= 0) || !this.childBestInterestUnderstanding);
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let childrenInfo = this.getChildrenResults()
        
        const counter = this.step.result?.rflmCounterAppSurvey?.data?.counter
        const selectedCounters = this.step.result?.rflmCounterAppSurvey?.data?.counterList
        if( (   this.correctChildInfo == 'Yes' &&  counter == 'Yes' ) && 
            (
                (selectedCounters.length==1 && selectedCounters?.includes('spousalSupport')) ||
                (selectedCounters.length==1 && selectedCounters?.includes('companionAnimal')) ||
                (selectedCounters.length==2 && selectedCounters?.includes('spousalSupport') && selectedCounters?.includes('companionAnimal'))
            )
        )
            childrenInfo = null
        
        this.UpdateStepResultData({step:this.step, data: {correctChildInfo: this.correctChildInfo, childrenInfoSurvey: childrenInfo , rflmChildBestInterestAcknowledgement:this.childBestInterestUnderstanding}})       
    }

    public getChildrenResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const child of this.childData)
        {
            questionResults.push({name:'childInfoSurvey', value: this.getChildInfo(child), title:'Child '+child.id +' Information', inputType:''})
        }
        
        return {data: this.childData, questions:questionResults, pageName:'Children Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(child.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(child.dob))
        if (this.includesCounter == 'Yes'){
            resultString.push(Vue.filter('styleTitle')("Your relationship: ")+child.relation)
            resultString.push(Vue.filter('styleTitle')("Other party’s relationship: ")+child.opRelation)
            if (child.currentLiving == 'other'){
                resultString.push(Vue.filter('styleTitle')("Living with: ")+child.currentLivingComment)
            } else {
                resultString.push(Vue.filter('styleTitle')("Living with: ")+child.currentLiving)
            }
        }        
        
        return resultString
    }  

    public resetChildrenRelatedPages(childData?) {
    
        const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        const p = stPgNo.RFLM;

        const pages = [ 
            p.ParentingArrangements,
            p.ParentalResponsibilities,
            p.ParentingTime,
            p.ParentingOrderAgreement,
            p.BestInterestsOfChild,
            p.ChildSupportCurrentArrangements,
            p.AboutChildSupportOrder,
            p.SpecialAndExtraordinaryExpenses,
            p.ContactWithChild,
            p.ContactWithChildOrder,
            p.AboutContactWithChildOrder,
            p.ContactWithChildBestInterestsOfChild,
            p.GuardianOfChild,           
            p.ReviewYourAnswersRFLM
        ]
        Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
